import React from 'react';
import man1 from '../../assets/img/man1.png';
import bgImg from '../../assets/img/map_pattern.png';
import FaqAccordion from '../FaqAccordion';

function Faq() {
    return (
        <section className="faq-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-12">
                        <div className="content-block">
                            <p>Întrebări Frecvente</p>
                            <h1>Răspunsuri la Întrebările Tale</h1>
                            <div className="bg-img">
                                <img src={bgImg} alt="" />
                                <div
                                    className="man bg-cover man-1"
                                    style={{
                                        backgroundImage: `url(${man1})`,
                                    }}
                                />
                                <div
                                    className="man bg-cover man-2"
                                    style={{
                                        backgroundImage: `url(${man1})`,
                                    }}
                                />
                                <div
                                    className="man bg-cover man-3"
                                    style={{
                                        backgroundImage: `url(${man1})`,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-12 mt-4 mt-xl-0">
                        <div className="faq-content">
                            <FaqAccordion
                                question="Ce servicii oferă Work Express?"
                                answer="Work Express oferă o gamă completă de servicii de construcții și renovări: izolații și hidroizolații, instalații electrice, vopsitorie și tapet, gleturi și finisaje, gips-carton, tencuieli și șape, montaj pardoseli, instalare AC, HVAC și IBIX."
                            />
                            <FaqAccordion
                                question="În ce zone activează Work Express?"
                                answer="Activăm în București și județul Ilfov, cu sediul în Măgurele. Suntem disponibili pentru proiecte rezidențiale și comerciale de orice dimensiune."
                            />
                            <FaqAccordion
                                question="Cât durează un proiect de renovare?"
                                answer="Durata unui proiect depinde de complexitatea și dimensiunea lucrărilor. După evaluarea inițială, vă oferim un plan detaliat cu termene clare de execuție. Ne mândrim cu respectarea termenelor stabilite."
                            />
                            <FaqAccordion
                                question="Oferiți garanție pentru lucrări?"
                                answer="Da, oferim garanție pentru toate lucrările executate. Perioada de garanție variază în funcție de tipul serviciului și materialele folosite. Lucrăm cu materiale premium și respectăm standardele ISO pentru calitate maximă."
                            />
                            <FaqAccordion
                                question="Cum pot solicita o ofertă?"
                                answer="Puteți solicita o ofertă gratuită prin telefon la 0724.273.258 sau prin email la office@reparatiiasfalt.ro. Oferim consultanță gratuită și evaluare la fața locului pentru a vă prezenta cea mai bună soluție pentru proiectul dumneavoastră."
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Faq;
